import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Meta } from '@angular/platform-browser';
import { StorageMap } from '@ngx-pwa/local-storage';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from 'app/core/services/shared.service';
import { StorageService } from '../../../core/services/storage/storage.service';
import { Language } from './language.model';

@Component({
    selector: 'upsc-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit, OnChanges {
    @Input() availableLanguages: Language[];
    @Input() useLanguage = 'en';

    public formGroup: UntypedFormGroup;

    constructor(private formBuilder: UntypedFormBuilder,
                private metaTagService: Meta,
                private storageService: StorageService,
                private storage: StorageMap,
                private sharedService: SharedService,
                private translateService: TranslateService,
    ) {
    }

    public ngOnInit() {
        this.formGroup = this.formBuilder.group({
            language: [this.useLanguage],
        });

        this.monitorValueChanges();
    }

    public ngOnChanges(changes: SimpleChanges) {
        this.onUseLanguageChanged(changes['useLanguage']);
    }

    public getFlag(languageCode: string): string {
        const language = this.availableLanguages.find(lang => lang.code === languageCode);
        if (!language) {
            return '';
        }

        return language.flag;
    }

    private monitorValueChanges() {
        this.onLanguageChanged();
    }

    private onLanguageChanged() {
        this.formGroup.controls.language.valueChanges
            .subscribe(
                (languageCode) => {
                    this.storageService.set('lang', languageCode);
                    this.storage.set('lang', languageCode).subscribe(() => {});
                    this.sharedService.langSubject.next(languageCode);
                    this.translateService.use(languageCode);
                    sessionStorage.setItem('lang', languageCode);
                    sessionStorage.setItem('site-locale', languageCode);

                    this.metaTagService.updateTag({ name: 'DCSext.pLL', content: languageCode });
                },
            );
    }

    private onUseLanguageChanged(change: SimpleChange) {
        if (!change || !change.currentValue) {
            return;
        }

        if (this.formGroup) {
            this.formGroup.patchValue({
                language: change.currentValue,
            });
        }
        
        this.storage.set('lang', change.currentValue).subscribe(() => {});
        this.translateService.use(change.currentValue);
        sessionStorage.setItem('lang', change.currentValue);
        sessionStorage.setItem('site-locale', change.currentValue);

        this.metaTagService.updateTag({ name: 'DCSext.pLL', content: change.currentValue });
    }
}
